import {
  IconCartFailed,
  IconCartFailedMobile,
  IconCartSuccess,
  IconCartSuccessMobile,
} from "@repo/assets/images";
import { useTranslations } from "next-intl";

const OrderStatusMessage = ({ isPaymentSuccess, message }) => {
  const t = useTranslations("Common");
  return (
    <>
      {isPaymentSuccess ? (
        <>
          <IconCartSuccess className="fill-icon-bg text-icon-color mx-auto hidden md:block" />
          <IconCartSuccessMobile className="fill-icon-bg text-icon-color mx-auto md:hidden" />
        </>
      ) : (
        <>
          <IconCartFailed className="fill-icon-bg text-icon-color mx-auto hidden md:block" />
          <IconCartFailedMobile className="fill-icon-bg text-icon-color mx-auto md:hidden" />
        </>
      )}
      <h1 className="font-heading rtl:font-arabic mx-auto max-w-80 py-6 text-center text-xl md:text-3xl">
        {message || t("Something_Went_Wrong_Please_Try_Again")}
      </h1>
    </>
  );
};
export default OrderStatusMessage;
